import { BoxProps } from '../layout'
import { system } from '../../system'

export type TextProps = BoxProps

export const Text = system('span')({
  fontVariantNumeric: 'lining-nums'
})
